import React from 'react'
import InjectionMouldingForm from './InjectionMouldingForm'
import get from "lodash/get"

const NotificationForm = ({initialValues,filter, getNotifications}) => {
    switch(get(filter, "templateType")){
        case 1:
        case 2:
        case 3:
        case 4:
        return(
            <InjectionMouldingForm initialValues={initialValues} filter={filter} getNotifications={getNotifications} />
        )
    }
}

export default NotificationForm